import { meetingContentFormatPattern } from "@/constants/record";

const formatMarkdown = (content?: string[], useMarkDownSummary = false, showBackTrace = false) => {
  if (!content) return content;
  if (useMarkDownSummary) {
    return content.map((item, index)=>{
      if(showBackTrace && (item.startsWith('\t') || item.startsWith('  '))){
        const nextItem = content[index+1];
        const backTraceSearchText = item.replace(/\t|-|\*/g, "");
        let showBackTraceIcon = !!backTraceSearchText.trim();
        if(nextItem){
          const currentItemLevel =  countLeadingTabs(item);
          const nextItemLevel = countLeadingTabs(nextItem);
          if(nextItemLevel > currentItemLevel){
            showBackTraceIcon = false;
          }
        }
        return showBackTraceIcon ? `${item}<ContentBacktraceIcon index=${index} item='${backTraceSearchText.replace(/'/g, '"')}'  ></ContentBacktraceIcon>` : item;
      }
      return item;
    }).join("  \n").replace(/\t/g, "  ").replace(/-\*\*/g, "- **");
  }
  return content.map((item, index) => {
      const formatItem = item.replace(meetingContentFormatPattern, "");
      return formatItem.trim() && showBackTrace
        ? `- ${formatItem}<ContentBacktraceIcon index=${index} item='${formatItem.replace(/'/g,'"')}'  />`
        : `- ${formatItem}`;
    })
    .join("  \n");
};

function countLeadingTabs(str: string) {
  const match = str.match(/^\t+/);
  return match ? match[0].length : 0;
}


export default formatMarkdown;